import {
  ActionIcon,
  CopyButton,
  Group,
  TextInput,
  Tooltip,
} from '@mantine/core';
import { IconCheck, IconCopy, IconExternalLink } from '@tabler/icons-react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { buildFarmerHarvestProofHref } from '../../utils/build-farmer-href';

interface HarvestProofFarmerLinkProps {
  temporaryLink: string;
  token: string;
}

export const HarvestProofFarmerLink: FC<HarvestProofFarmerLinkProps> = ({
  temporaryLink,
  token,
}) => {
  const { t } = useTranslation();

  return (
    <Group align="flex-end" gap="xs" wrap="nowrap">
      <TextInput
        flex={1}
        label={t('harvest-proof.farmerLink.label')}
        readOnly
        value={temporaryLink}
      />
      <CopyButton timeout={2000} value={temporaryLink}>
        {({ copied, copy }) => (
          <Tooltip
            label={
              copied
                ? t('harvest-proof.farmerLink.copied')
                : t('harvest-proof.farmerLink.copy')
            }
          >
            <ActionIcon
              aria-label={t('harvest-proof.farmerLink.copy')}
              color={copied ? 'teal' : 'gray'}
              onClick={copy}
              size="lg"
              variant="light"
            >
              {copied ? <IconCheck size={18} /> : <IconCopy size={18} />}
            </ActionIcon>
          </Tooltip>
        )}
      </CopyButton>
      <Tooltip label={t('harvest-proof.farmerLink.open')}>
        <ActionIcon
          aria-label={t('harvest-proof.farmerLink.open')}
          component="a"
          href={buildFarmerHarvestProofHref(token)}
          size="lg"
          target="_blank"
          variant="light"
        >
          <IconExternalLink size={18} />
        </ActionIcon>
      </Tooltip>
    </Group>
  );
};
